<template>
    <section class="tukivita_list_wrp">
        <div class="tukivita_list_inner">
            <div class="tukivita_list_body">
                <div class="tukivita_card">
                        <h3 class="tukivita_card_heading">Meet TukiVita</h3>
                        <p class="tukivita_card_subheading">Where intelligent support meets precision in oncology</p>
                        <div class="tukivita_card_dp">
                            <img src="@/assets/images/circle_bot_icon.png" class="img-fluid">
                        </div>
                        <div class="tukivita_card_info">
                            <p>Your intelligent companion at the heart of Lymphomap - built to simplify oncology insights, research, and navigation.</p>
                            <p>Sign up now to experience smarter, AI-driven support designed for you.</p>
                        </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
/*eslint-disable */
export default {
    name: 'tukivita-list',
    components: {
    },
    data() {
        return {
        }
    },
}
</script>

<style lang="scss" scoped>
.tukivita_list_wrp {
    min-height: 100dvh;
    padding:70px 10px 10px;

    .tukivita_list_inner {
        color: #ffffff;
        font-family: 'MyriadProRegular','Lato',sans-serif;
        background: rgba(0, 0, 0, 0.75);
        min-height: calc(100dvh - 80px);
        display: flex;
        width: 100%;
        align-items: center;

        @media only screen and (max-width:767px) {
            min-height: inherit;
        }

        .main_heading {
            color: #ffffff;
            font-size: 24px;
            text-transform: uppercase;
            font-weight: bold;
            margin: 0px;
        }

        .tukivita_list_body {
            width: 100%;
            .tukivita_card {
                background: linear-gradient(-30deg, rgba(37, 44, 84, 0.6) 0%, rgba(0, 0, 0, 0.6) 50%, rgba(38, 38, 38, 0.6) 50%, rgba(44, 44, 84, 0.6) 100%);
                border: 1px solid rgba(93, 93, 93, 0.4);
                border-radius: 8px;
                text-align: center;
                max-width: 1040px;
                margin: 0 auto;
                padding: 80px 15px;
                .tukivita_card_dp {
                    height: 142px;
                    display: block;
                    max-width: 100%;
                    text-align: center;

                    .img-fluid {
                        object-fit: cover;
                        object-position: center center;
                    }
                }

                .tukivita_card_heading {
                    color: #d29e00;
                    font-size: 42px;
                    margin-bottom: 20px;
                    font-family: 'origin_tech_demoregular';
                    line-height: 1;
                    @media only screen and (max-width:767px) {
                     font-size: 32px;
                    }
                }

                .tukivita_card_subheading {
                    font-size: 18px;
                    color: #fff2b3;
                    margin-bottom: 40px;
                    line-height: 1;
                    text-transform: capitalize;
                    @media only screen and (max-width:767px) {
                     font-size: 16px;
                     line-height: 1.3;
                    }
                }
                .tukivita_card_info{
                    padding-top: 20px;
                    p{
                        font-size: 16px;
                        font-family: arial;
                        color: #ffffff;
                        margin-top: 10px;
                        margin-bottom: 0px;
                        line-height: 1;
                        @media only screen and (max-width:767px) {
                        font-size: 14px;
                        line-height: 1.3;
                        }
                    }
                }
            }
        }
    }

}
</style>